import React, { useEffect, useState } from "react";
import { Card } from "@ui/card";
import { Separator } from "@ui/separator";
import { BasicSwitch } from "@components/items/display/Switch";
import {
  clearNextContent,
  setAutoPlay,
  setNextTitle,
  useAppDispatch,
  useAppSelector,
} from "@lib/stores";
import { AuthActions } from "@lib/stores/auth/slices";
import { SettingActions } from "@lib/stores/settings/slices";
import { useAudioPlayer } from "@modules/content/AudioPlayerContext";
import TranslatedText from "@components/items/display/TranslatedText";
import { ResourcesKey } from "@modules/localizations/translate";

const ReadingandListeningSettingsTab = () => {
  const dispatch = useAppDispatch();

  const [isAutoPlay, setIsAutoPlay] = useState<boolean>();
  const [isNextTitleOn, setIsNextTitleOn] = useState<boolean>();

  const user = useAppSelector((state) => state.auth.user);

  const { changeIsAutoStart } = useAudioPlayer();

  useEffect(() => {
    if (
      user.autoPlayDisabled !== undefined &&
      user.nextTitleDisabled !== undefined
    ) {
      setIsAutoPlay(!user.autoPlayDisabled);
      setIsNextTitleOn(!user.nextTitleDisabled);
    }
  }, [user.autoPlayDisabled, user.nextTitleDisabled]);

  useEffect(() => {
    dispatch(SettingActions.getDownloadsAsync());
  }, [dispatch]);

  const handleAutoPlayChange = (value: boolean) => {
    try {
      setIsAutoPlay(value);
      changeIsAutoStart(value);
      const input = { disabled: !value };
      setAutoPlay(input, () => {
        dispatch(AuthActions.getMyInfoAsync());
      });
    } catch (error) {
      setIsAutoPlay(isAutoPlay);
      changeIsAutoStart(Boolean(isAutoPlay));
      console.log("error", error);
    }
  };

  const handleNextTitleChange = (value: boolean) => {
    try {
      setIsNextTitleOn(value);
      const input = { disabled: !value };
      setNextTitle(input, () => {
        dispatch(AuthActions.getMyInfoAsync());

        clearNextContent();
      });
    } catch (error) {
      setIsNextTitleOn(isNextTitleOn);
      console.log("error", error);
    }
  };

  return (
    <div className="flex w-full items-center justify-center p-5">
      <Card className="flex flex-col items-start justify-center border-none bg-[#D9D9D9]/15 p-5">
        <SettingItem
          titleKey="auto play title"
          descriptionKey="auto play body"
          checked={Boolean(isAutoPlay)}
          onCheckedChange={handleAutoPlayChange}
        />
        <Separator className="my-5 dark:bg-[#D9D9D9]/15" />
        <SettingItem
          titleKey="next title title"
          descriptionKey="next title body"
          checked={Boolean(isNextTitleOn)}
          onCheckedChange={handleNextTitleChange}
        />
        <Separator className="my-5 dark:bg-[#D9D9D9]/15" />
        {/* <SettingItem
          titleKey="download via Wi-Fi only"
          descriptionKey="when this feature is turned on, any summary will be downloaded when connected to a Wi-Fi network"
          checked={false}
          onCheckedChange={(value) => console.log({ value })}
        /> */}
        {/* <Separator className="my-5 dark:bg-[#D9D9D9]/15" />
        <div className="flex justify-between items-center w-full">
          <TranslatedTextTemp
            text="settings.titles.delete all downloads"
            origintext="delete all downloads"
            className="text-[15px] font-medium"
          />
          <DeleteDownloadsDialog downloadIds={downloadIds} />
        </div> */}
      </Card>
    </div>
  );
};

export default ReadingandListeningSettingsTab;

const SettingItem = ({
  titleKey,
  descriptionKey,
  checked,
  onCheckedChange,
}: {
  titleKey: string;
  descriptionKey: string;
  checked: boolean;
  onCheckedChange: (value: boolean) => void;
}) => (
  <div className="mx-auto grid w-[580px] grid-cols-6 items-center justify-between">
    <div className="col-span-4 flex flex-col items-start justify-center gap-2 ltr:text-left rtl:text-right">
      <TranslatedText
        text={`settings.titles.${titleKey}` as ResourcesKey}
        className="text-[15px] font-medium text-black dark:text-white"
      />
      <TranslatedText
        text={`settings.titles.${descriptionKey}` as ResourcesKey}
        className="text-wrap text-[12px] text-black dark:text-white"
      />
    </div>
    <div className="col-end-7">
      <BasicSwitch
        activeClassName="data-[state=checked]:bg-[#34C759] dark:data-[state=checked]:bg-[#34C759] data-[state=unchecked]:bg-[#D9D9D9]"
        checked={checked}
        onCheckedChange={onCheckedChange}
      />
    </div>
  </div>
);
